module.exports = __webpack_public_path__ + "img/img_analyist_peng_lg.58b7b686.png";